/**
 * Single switch for the task-notification feature: header badge, REST polling,
 * and the /ws/tasks/notifications/ WebSocket.
 *
 * Disable with `REACT_APP_TASK_NOTIFICATIONS_ENABLED=false` in the build env
 * (e.g. .env.production) and rebuild. Re-enable by setting it to `true` or
 * removing the override.
 */
export const TASK_NOTIFICATIONS_ENABLED =
  String(process.env.REACT_APP_TASK_NOTIFICATIONS_ENABLED ?? 'true').trim().toLowerCase() !== 'false';
